import { WatchQueryFetchPolicy } from '@apollo/client';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import { ActivitiesContentType } from 'global/constants';
import { GET_TEACHER_ANSWER_BY_ID } from './get-teacher-answer-by-id.graphql';
import type { GetTeacherAnswerByIdQueryVariables } from './get-teacher-answer-by-id.graphql.generated';
import type { GetTeacherAnswerByIdQuery } from './get-teacher-answer-by-id.graphql.generated';

const useGetTeacherAnswerById = ({
  uuid,
  classId,
  contentId,
  contentType,
  skip,
  fetchPolicy,
}: {
  uuid: string;
  classId: number;
  contentId: number;
  contentType: ActivitiesContentType;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
}) => {
  const { data, loading, error } = useLoggingQuery<
    GetTeacherAnswerByIdQuery,
    GetTeacherAnswerByIdQueryVariables
  >(GET_TEACHER_ANSWER_BY_ID, {
    skip,
    fetchPolicy,
    variables: {
      input: {
        classId,
        contentId,
        contentType,
        uuid,
      },
    },
  });

  return {
    data,
    loading,
    error,
  };
};

export default useGetTeacherAnswerById;
